import { HookFormText } from 'lib-shared-hook-form';
import { memo } from 'react';
import { useWatch } from 'react-hook-form';

import {
  CustomFieldStringAttributeValue,
  CustomFieldTextAttribute,
} from 'apis/customFields';
import { useCopy } from 'utils/useCopy';

import { BaseCustomFieldProps } from '../customFields.types';

type BaseCustomFieldTextProps = BaseCustomFieldProps<
  CustomFieldTextAttribute,
  CustomFieldStringAttributeValue,
  Record<string, string>
> & {
  /** Whether to show the label line */
  noLabel?: boolean;
  /** Whether to show the alert line */
  noAlert?: boolean;
  /** Whether to show the copy button */
  noCopy?: boolean;
};

export const BaseCustomFieldText = memo(function BaseCustomFieldText({
  control,
  customField,
  rules,
  name,
  warning,
  componentProps,
  noLabel,
  noAlert,
  noCopy,
}: BaseCustomFieldTextProps): JSX.Element {
  const { attribute } = customField;
  const { label, description, id, placeholder } = attribute;

  const [copyToClipboard, copyState] = useCopy();
  const fieldName = name ?? id;
  const fieldValue = useWatch({ control, name: fieldName });

  return (
    <HookFormText
      control={control}
      label={label}
      noLabel={noLabel}
      noAlert={noAlert}
      name={fieldName}
      helpIcon={{
        text: description,
      }}
      rules={rules}
      meta={{
        warning,
      }}
      componentProps={{
        ...componentProps,
        placeholder,
        suffix: noCopy
          ? undefined
          : {
              type: 'button',
              button: {
                icon: copyState.status === 'copied' ? 'done' : 'copy',
                onClick: () => copyToClipboard(fieldValue),
              },
            },
      }}
    />
  );
});
